import { UPDATE_TRAIL } from './actions';

const initialState = {
  trail: [],
};

export function reducer(state = structuredClone(initialState), action) {
  if (action.type === UPDATE_TRAIL) {
    return { ...state, trail: action.trail };
  }
  return state;
}
